
import { mapGetters } from 'vuex'
import btn from '../components/btn.vue'

export default {
    components: {
        btn
    },
    data () {
        return {
        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            workOrder35Progress: 'ry/workOrder35Progress',
            imOrderInfo: 'ry/imOrderInfo'
        }),
        nodeInfo () {
            if (!this.workOrder35Progress.nodeInfo) {
                return {}
            }
            const nodeInfo = {}
            this.workOrder35Progress.nodeInfo.forEach(item => {
                nodeInfo[item.id] = item
            })
            return nodeInfo
        },
        noticeContent () {
            return this.workOrder35Progress.broadcastsMsg
        },
        isSeller () {
            return +this.imOrderInfo.sellerId === +this.userinfo.id
        },
        showBtn () {
            const { permissionsMulti } = this.workOrder35Progress
            if (!permissionsMulti) { return false }
            if (this.isSeller) {
                // 2卖家
                return permissionsMulti.includes('2')
            } else {
                // 1买家
                return permissionsMulti.includes('1')
            }
        }
    },
    created () {},
    methods: {
        clickBtn () {
            const { cardId } = this.workOrder35Progress
            const cards = document.querySelectorAll(`.workOrder35Card_${cardId}`)

            // 添加空值检查
            if (!cards || cards.length === 0) {
                console.warn('未找到对应的卡片元素')
                return
            }

            const lastCard = cards[cards.length - 1]

            // 检查lastCard是否存在
            if (!lastCard) {
                console.warn('未找到最后一个卡片')
                return
            }

            // 获取dom下的.workOrder35Btn
            const btns = lastCard.querySelectorAll('.workOrder35Btn')

            // 检查按钮是否存在
            if (!btns || btns.length === 0) {
                console.warn('未找到按钮元素')
                return
            }

            const btn = btns.length == 2 ? btns[1] : btns[0]

            if (btn.disabled) {
                return this.$message.warning('该操作已失效')
            }
            // 点击按钮
            try {
                btn.click()
            } catch (error) {
                console.error('点击按钮时发生错误:', error)
            }
        }
    }
}
